import React, { useContext } from 'react';
import { ReactSVG } from 'react-svg';
import { FormattedMessage, useIntl } from 'react-intl';
import { useForm } from 'react-hook-form';
import image from '../../../assets/image/welcome/slide1.svg';
import CustomBtn from '../../../generic/CustomBtn';
import { ContextForm } from '../../../utils/projectRegistration';
import CustomCheckbox from '../../../generic/CustomCheckbox';
import storage from '../../../utils/storage';

const OneProjectPathways = () => {
  const translate = useIntl();
  const { formData, setFormData } = useContext(ContextForm);
  const { handleSubmit, register } = useForm({
    mode: 'all',
    defaultValues: {
      isInterest: null,
    },
  });

  const onSubmit = (data) => {
    storage.set('isInterest', {
      project_id: '',
      isInterest: data.isInterest,
    });
    setFormData({ ...formData, isProjectRegisterForm: false });
  };

  return (
    <div className="project-register__oneProjectPathways">
      <ReactSVG src={image} className="welcome__image" />
      <h2 className="project-register__title">
        {translate.formatMessage({ id: 'project-register.launchANewProject' })}
      </h2>
      <FormattedMessage
        id="project-register.oneProjectPathwaysDescription"
        values={{
          p: (...chunks) => <p className="project-register__subtitle project-register__oneProjectPathwaysText">{chunks}</p>,
          br: <br />,
        }}
      />
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="project-register__checkBoxWrapper">
          <CustomCheckbox
            type="checkbox"
            register={register}
            name="isInterest"
            title={translate.formatMessage({ id: 'project-register.oneProjectPathwaysInterested' })}
          />
        </div>
        <CustomBtn
          label={translate.formatMessage({ id: 'button-saveProceed' })}
          type="button"
          handleClick={() => {}}
          customClass="btn__btn-next"
        />
      </form>
    </div>
  );
};

export default OneProjectPathways;
